module.exports = __webpack_public_path__ + "img/faq-illustrations.8647b574.svg";